/** Normalize backend si to 0 or 1. */
export function normalizeSi(value) {
  if (value === true || value === 1 || value === "1" || value === "true") return 1;
  if (value === false || value === 0 || value === "0" || value === "false") return 0;
  return 0;
}

/**
 * SI status for schedule / 4D display.
 * - complete (green): si = 1
 * - pending (yellow): si = 0 and planned finish not yet passed (or missing)
 * - overdue (red): si = 0 and planned finish date has passed
 */
export function getSiStatus({ si, plannedEnd }) {
  if (normalizeSi(si) === 1) return "complete";

  const finish = plannedEnd ? String(plannedEnd).slice(0, 10) : "";
  if (!finish) return "pending";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(finish);
  if (Number.isNaN(end.getTime())) return "pending";
  end.setHours(0, 0, 0, 0);

  return end >= today ? "pending" : "overdue";
}

export function getSiStatusColor(status) {
  switch (status) {
    case "complete":
      return "#4caf50";
    case "pending":
      return "#ffc107";
    case "overdue":
      return "#f44336";
    default:
      return "#9e9e9e";
  }
}

/** Worst-case status for a group of subtasks (overdue > pending > complete). */
export function aggregateSiStatus(subtasks) {
  if (!Array.isArray(subtasks) || subtasks.length === 0) return "pending";

  const statuses = subtasks.map((t) =>
    getSiStatus({
      si: t.si,
      plannedEnd:
        t.revisedEnd ||
        t.baselineEnd ||
        t.endDate ||
        t.plannedEnd,
    }),
  );

  if (statuses.includes("overdue")) return "overdue";
  if (statuses.includes("pending")) return "pending";
  return "complete";
}

/** Update si on a single task in an array (by id or scheduleTaskId). */
export function patchTaskSiInList(list, taskId, si) {
  if (!Array.isArray(list) || taskId == null) return list;
  const idStr = String(taskId);
  return list.map((item) => {
    const itemId = item?.scheduleTaskId ?? item?.id;
    return itemId != null && String(itemId) === idStr ? { ...item, si } : item;
  });
}
